import React, { Component } from 'react'
import Container from '@mui/material/Container'
import CssBaseline from '@mui/material/CssBaseline'
import Typography from '@mui/material/Typography'
import Card from '@mui/material/Card'
import CardMedia from '@mui/material/CardMedia'
import { Button } from '@mui/material'
import Slide from '@mui/material/Slide'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'

// Components
import HeadGlobal from './headerGlobal'

// Utils
import {
  welcomeEs,
  welcomeFr,
  welcomeEn,
  welcomePtg,
} from '../textApp/textTrad'
import reebok from '../assets/images/reebok.png'
import nike from '../assets/images/nike.png'
import samsung from '../assets/images/samsung.png'
import apple from '../assets/images/apple.png'
import { navigationGA } from '../data/GA'

class BrandSel extends Component {
  constructor(props) {
    super(props)

    this.state = {
      branded: '',
    }
    this.continue = this.continue.bind(this)
    this.selectBrand = this.selectBrand.bind(this)
    this.handleBrandUsed = this.handleBrandUsed.bind(this)
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const userBef = JSON.parse(localStorage.getItem('dataUser'))
    const { socDis, catego, setCatego, setSocDis } = nextProps
    if ((!socDis || !catego) && userBef) {
      setCatego(userBef.catego)
      setSocDis(userBef.socDis)
    }
    return null
  }
  componentDidUpdate() {
    const { navigate } = this.props
    const userBef = JSON.parse(localStorage.getItem('dataUser'))
    if (!userBef || !userBef.catego || !userBef.socDis) {
      navigate('/noSurvey')
    }
  }

  selectLang = () => {
    const { lng } = this.props
    switch (lng) {
      case 'es':
        return welcomeEs
      case 'fr':
        return welcomeFr
      case 'en':
        return welcomeEn
      case 'pt':
        return welcomePtg
      default:
        return welcomeEn
    }
  }
  selectBrand = (brand) => {
    this.setState({
      branded: brand,
    })
  }
  continue = () => {
    const { navigate, location, setBrand, brandUsed } = this.props
    const userBef = JSON.parse(localStorage.getItem('dataUser'))
    if (!userBef || !userBef.catego || !userBef.socDis) {
      navigate(-1)
    }
    const { branded } = this.state

    if (branded && brandUsed) {
      navigate('/video' + location.search)
      setBrand(branded)
      const userBef = JSON.parse(localStorage.getItem('dataUser'))
      localStorage.setItem(
        'dataUser',
        JSON.stringify({
          ...userBef,
          brand: branded,
          brandUsed: brandUsed,
        })
      )
    } else {
      const txt = this.selectLang()
      alert(txt.selBrand)
    }
  }
  handleBrandUsed = (e) => {
    const { setUsed } = this.props
    setUsed(e.target.name)
  }
  render() {
    const { branded } = this.state
    const { setlang, catego, socDis, brandUsed } = this.props
    // console.log('props', this.props)
    const txt = this.selectLang()
    const shadow = 10
    const scale = 'scale(1.05)'
    const background = 'rgba(232, 78, 14, 0.5)'
    // Google Analytcs Page View
    navigationGA('Brand Selection', 'brandsel', 'brandsel')
    return (
      <div className='center'>
        <div className='main'>
          <CssBaseline>
            <HeadGlobal setlang={setlang} changeLang={true} />
          </CssBaseline>
          <Typography
            component='h1'
            variant='h4'
            align='center'
            sx={{
              fontWeight: '700',
              paddingBottom: '2vh',
              fontSize: {
                xs: '1.5rem',
                sm: '1.5rem',
                md: '2rem',
              },
            }}
          >
            {socDis === 'near'
              ? txt.brandSel
              : socDis === 'dis'
              ? txt.brandDistant
              : ''}
          </Typography>
          <Slide
            direction='right'
            in={true}
            mountOnEnter
            unmountOnExit
            timeout={700}
          >
            <Container
              sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gridGap: '2rem',
                alignItems: 'center',
                justifyItems: 'center',
              }}
            >
              {/* 
            //////////
            REEBOK CARD 
            /////////
            */}
              {catego === '01' && (
                <Card
                  onClick={() => this.selectBrand('reebok')}
                  sx={{
                    maxWidth: 245,
                    padding: '1vh 1vw',
                    transition: 'all .3s',
                    boxShadow: branded === 'reebok' ? shadow : '1',
                    transform: branded === 'reebok' ? scale : '0',
                    background:
                      branded === 'reebok' ? background : 'transparent',
                    ':hover': {
                      boxShadow: 10,
                      transform: 'scale(1.05)',
                      transition: '.3s',
                    },
                  }}
                >
                  <CardMedia
                    component='img'
                    height='98%'
                    image={reebok}
                    alt='reebok'
                  ></CardMedia>
                </Card>
              )}
              {/* 
            //////////
            NIKE CARD 
            /////////
            */}
              {catego === '01' && (
                <Card
                  onClick={() => this.selectBrand('nike')}
                  sx={{
                    boxShadow: branded === 'nike' ? shadow : '1',
                    transform: branded === 'nike' ? scale : '0',
                    background: branded === 'nike' ? background : 'transparent',
                    maxWidth: 245,
                    padding: '1vh 1vw',
                    transition: 'all .3s',
                    ':hover': {
                      boxShadow: 10,
                      transform: 'scale(1.05)',
                      transition: '.3s',
                    },
                  }}
                >
                  <CardMedia
                    component='img'
                    height='95%'
                    image={nike}
                    alt='nike'
                  ></CardMedia>
                </Card>
              )}
              {/* 
            //////////
            SAMSUNG CARD 
            /////////
            */}
              {catego === '02' && (
                <Card
                  onClick={() => this.selectBrand('samsung')}
                  sx={{
                    boxShadow: branded === 'samsung' ? shadow : '1',
                    transform: branded === 'samsung' ? scale : '0',
                    background:
                      branded === 'samsung' ? background : 'transparent',
                    maxWidth: 245,
                    padding: '1vh 1vw',
                    transition: 'all .3s',
                    ':hover': {
                      boxShadow: 10,
                      transform: 'scale(1.05)',
                      transition: '.3s',
                    },
                  }}
                >
                  <CardMedia
                    component='img'
                    height='95%'
                    image={samsung}
                    alt='samsung'
                  ></CardMedia>
                </Card>
              )}
              {/* 
            //////////
            APPLE CARD 
            /////////
            */}
              {catego === '02' && (
                <Card
                  onClick={() => this.selectBrand('apple')}
                  sx={{
                    boxShadow: branded === 'apple' ? shadow : '1',
                    transform: branded === 'apple' ? scale : '0',
                    background:
                      branded === 'apple' ? background : 'transparent',
                    maxWidth: 245,
                    padding: '1vh 1vw',
                    transition: 'all .3s',
                    ':hover': {
                      boxShadow: 10,
                      transform: 'scale(1.05)',
                      transition: '.3s',
                    },
                  }}
                >
                  <CardMedia
                    component='img'
                    height='95%'
                    image={apple}
                    alt='apple'
                  ></CardMedia>
                </Card>
              )}
            </Container>
          </Slide>
          {/* //////
          USED THE BRAND
          //////////  */}
          {catego && (
            <Slide
              direction='right'
              in={true}
              mountOnEnter
              unmountOnExit
              timeout={700}
            >
              <Container
                sx={{
                  display: 'grid',
                  justifyContent: 'center',
                  justifyItems: 'center',
                  fontSize: '2rem',
                }}
              >
                <Typography
                  component='h1'
                  variant='h3'
                  align='center'
                  sx={{
                    fontWeight: '600',
                    marginTop: '3vh',
                    fontSize: {
                      xs: '1.2rem',
                      sm: '1.2rem',
                      md: '1.4rem',
                    },
                  }}
                >
                  {txt.usedBrand}
                </Typography>
                <FormControlLabel
                  sx={{
                    ' & .css-ahj2mt-MuiTypography-root': { fontSize: '1.5rem' },
                  }}
                  control={
                    <Checkbox
                      checked={brandUsed === 'yes' ? true : false}
                      onChange={this.handleBrandUsed}
                      name='yes'
                      sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                    />
                  }
                  label={txt.yes}
                />
                <FormControlLabel
                  sx={{
                    ' & .css-ahj2mt-MuiTypography-root': { fontSize: '1.5rem' },
                  }}
                  control={
                    <Checkbox
                      checked={brandUsed === 'no' ? true : false}
                      onChange={this.handleBrandUsed}
                      name='no'
                      sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                    />
                  }
                  label={txt.no}
                />
              </Container>
            </Slide>
          )}
          {/* //////
          BOUTON NEXT
          //////////  */}
          <Button
            onClick={this.continue}
            variant='contained'
            sx={{
              marginTop: '2vh',
              padding: {
                xs: '1rem 4rem',
                sm: '1rem 2rem',
                md: '1rem 2rem',
              },
              fontSize: {
                xs: '1.2rem',
                sm: '1.5rem',
                md: '1.7rem',
              },
            }}
          >
            {txt.cont}
          </Button>
        </div>
      </div>
    )
  }
}
export default BrandSel
